import React from 'react';
import './Loader.scss';

const Loader = (props) => (
  <div className="section__loader"/>
);

export default Loader;